import { Route, Routes } from "react-router-dom";
import { CryptoEditorPage } from "./pages";

export const ConfigEditorRouter = () => {
  return (
    <Routes>
      <Route path="crypto" element={<CryptoEditorPage />} />
    </Routes>
  );
};
